export default "__VITE_ASSET__Do7Xf99C__"